export default {
  loading: { to: '/loading' },
  pravoEu: {
    list: {
      to: '/vyhladavanie-v-prave-eu',
      name: 'Právo EÚ',
    },
    detail: {
      to: '/:uuid',
      withParams: (uuid: string | undefined): string => `/${uuid}`,
    },
  },
  navrhyAktovEu: {
    list: {
      to: '/navrhy-aktov-eu',
      name: 'Návrhy aktov EÚ',
    },
    detail: {
      to: '/navrhy-aktov-eu/:uuid',
      withParams: (uuid: string | undefined): string => `/navrhy-aktov-eu/${uuid}`,
    },
  },
};
